import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { PrioritySpinnerService } from '../services/priority-spinner.service';

let activeRequests = 0;

export const spinnerInterceptor: HttpInterceptorFn = (req, next) => {
  const spinner = inject(PrioritySpinnerService);
  const apiUrl = environment.api.url;

  // Show spinner only if request is an API call or loads world.json
  const showSpinner = req.url.startsWith(apiUrl) || req.url.includes('world.json');

  if (showSpinner) {
    if (activeRequests === 0) {
      spinner.show();
    }
    activeRequests++;
  }

  return next(req).pipe(
    finalize(() => {
      // add small delay to avoid flickering if requests are made in quick succession
      setTimeout(() => {
        if (showSpinner) {
          activeRequests--;
          if (activeRequests === 0) {
            spinner.hide();
          }
        }
      }, 100);
    })
  );
};
